import { z } from "zod";
/**
 * Unit labels offered as presets in the line editor (spec §3, §10).
 *
 * `NO` is the default — every line on the real invoices is `1.000 NO`. `AU` is
 * what the parent/group-header rows print. `MT` appears on the quotation_lines
 * column list in §3.
 */
export const UNIT_LABELS = ["NO", "AU", "EA", "SET", "JOB", "kg", "MT", "meter"];
/** Preset-only schema, for places that must not accept a free-typed unit. */
export const UnitLabelPresetSchema = z.enum(UNIT_LABELS);
/** Default unit for a new line (spec §3.1 smart defaults). */
export const DEFAULT_UNIT_LABEL = "NO";
/** Maximum length of a custom unit label — it has to fit the PDF QTY column. */
export const UNIT_LABEL_MAX_LENGTH = 10;
/**
 * Unit label as accepted on a document line. The dropdown offers
 * {@link UNIT_LABELS}, but spec §10 requires a "type your own" option, so any
 * short non-empty string is valid.
 */
export const UnitLabelSchema = z
    .string()
    .trim()
    .min(1, "Unit is required")
    .max(UNIT_LABEL_MAX_LENGTH, `Unit must be ${UNIT_LABEL_MAX_LENGTH} characters or fewer`);
//# sourceMappingURL=units.js.map